import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';

import { ResultType } from '../types/result.types.ts';
import { getReadingCrittersClientUtil } from '../utils/clients/readingcritters.client.util.ts';

const GENERATE_CHARACTER_SPEECH_MUTATION = mutation({
  generateCharacterSpeech: [
    { input: input('input', 'GenerateCharacterSpeechInput!') },
    {
      id: true,
    },
  ],
});

type GenerateCharacterSpeechInputType = VariablesOf<typeof GENERATE_CHARACTER_SPEECH_MUTATION>['input'];
type GenerateCharacterSpeechResponseType = ResultOf<
  typeof GENERATE_CHARACTER_SPEECH_MUTATION
>['generateCharacterSpeech'];

export const generateCharacterSpeechMutationRequest = async (
  props: GenerateCharacterSpeechInputType
): Promise<ResultType<GenerateCharacterSpeechResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(GENERATE_CHARACTER_SPEECH_MUTATION, { input: props }, { useAuth: true });

  return {
    success: Boolean(response?.generateCharacterSpeech?.id),
    data: response?.generateCharacterSpeech ?? { id: '' },
  };
};
